/* Adapted from responsive_tables.js by ZURB Foundation */

export default function () {
  const addSplitClass = function (element) {
    return $(element).addClass('ResponsiveTable--split');
  };

  const removeSplitClass = function (element) {
    return $(element).removeClass('ResponsiveTable--split');
  };

  const getSplitClass = function (element) {
    return $(element).hasClass('ResponsiveTable--split');
  };

  const setCellHeights = function (original, copy) {
    const tr = original.find('tr');
    const trCopy = copy.find('tr');

    for (let i = 0; i < tr.length; i++) {
      const height = Math.max($(tr[i]).height(), $(trCopy[i]).height());
      $(tr[i]).height(height);
      $(trCopy[i]).height(height);
    }
  };

  const splitTable = function ($original) {
    const $nestedTable = $($original.find('table.responsive, table.responsiveWithAvatar'));
    const withAvatarClass = ($nestedTable.hasClass('responsiveWithAvatar') ? 'WithAvatar' : '');
    $nestedTable.wrap("<div class='responsiveTableWrapper' />");

    const copy = $nestedTable.clone();
    copy.removeClass(`responsive${withAvatarClass}`);

    $nestedTable.closest('.responsiveTableWrapper').append(copy);
    copy.wrap(`<div class='pinned${withAvatarClass}' />`);
    $nestedTable.wrap("<div class='scrollable' />");

    setCellHeights($nestedTable, copy);
  };

  const unsplitTable = function ($original) {
    const $nestedTable = $($original.find('table.responsive, table.responsiveWithAvatar'));
    $nestedTable.closest('.responsiveTableWrapper').find('.pinned, .pinnedWithAvatar').remove();
    $nestedTable.unwrap();
    $nestedTable.unwrap();
  };

  const updateTables = function () {
    $('.ResponsiveTable').each((_, element) => {
      const splitWidth = $(element).data('split-width');

      if (($(window).width() < splitWidth) && !getSplitClass(element)) {
        addSplitClass(element);
        splitTable($(element));
      } else if (getSplitClass(element) && ($(window).width() >= splitWidth)) {
        removeSplitClass(element);
        unsplitTable($(element));
      }
    });
  };

  const windowEvent = function (e) {
    if (!e) { removeSplitClass($('.ResponsiveTable')); }
    updateTables();
  };

  windowEvent();
  $(window).on('redraw resize', windowEvent);
}
